import { z } from 'zod';
// API Response Types
export const ApiResponseSchema = z.object({
    success: z.boolean(),
    data: z.any().optional(),
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.any().optional(),
        retryable: z.boolean(),
    }).optional(),
    requestId: z.string(),
    timestamp: z.string(),
});
// Demo Runtime Types
export const DemoResponseSchema = z.object({
    agentId: z.string(),
    message: z.string(),
    reasoning: z.array(z.string()).optional(),
    sources: z.array(z.string()).optional(),
    timestamp: z.string(),
    sessionId: z.string(),
});
// Session Management
export const SessionStateSchema = z.object({
    sessionId: z.string(),
    demoId: z.string(),
    userId: z.string().optional(),
    messages: z.array(z.object({
        id: z.string(),
        role: z.enum(['user', 'agent']),
        content: z.string(),
        agentId: z.string().optional(),
        timestamp: z.string(),
    })),
    context: z.record(z.string(), z.any()).optional(),
    createdAt: z.string(),
    lastActivity: z.string(),
});
// Analytics Types
export const AnalyticsSchema = z.object({
    demoId: z.string(),
    totalViews: z.number(),
    uniqueUsers: z.number(),
    averageSessionDuration: z.number(),
    messageCount: z.number(),
    agentInteractions: z.record(z.string(), z.number()),
    popularQueries: z.array(z.string()),
    timeRange: z.object({
        start: z.string(),
        end: z.string(),
    }),
});
// Cost Estimation
export const CostEstimateSchema = z.object({
    demoId: z.string(),
    estimatedMonthlyCost: z.number(),
    breakdown: z.object({
        lambda: z.number(),
        bedrock: z.number(),
        s3: z.number(),
        dynamodb: z.number(),
        apiGateway: z.number(),
        cloudfront: z.number(),
    }),
    usage: z.object({
        monthlyViews: z.number(),
        averageMessagesPerSession: z.number(),
        bedrockTokensPerMonth: z.number(),
    }),
});
// Demo Creation Conversation Types
export const ConversationResponseSchema = z.object({
    conversationId: z.string(),
    response: z.string(),
    isComplete: z.boolean(),
    suggestedQuestions: z.array(z.string()).optional(),
});
export const DemoCreationResultSchema = z.object({
    demoId: z.string(),
    publicUrl: z.string(),
    configFiles: z.object({
        config: z.string(),
        agents: z.string(),
        examples: z.string(),
        seed: z.string(),
    }),
});
export const ConversationStartRequestSchema = z.object({
    prompt: z.string(),
});
export const ConversationContinueRequestSchema = z.object({
    conversationId: z.string(),
    message: z.string(),
});
export const ConversationFinalizeRequestSchema = z.object({
    conversationId: z.string(),
    summary: z.string(),
});
//# sourceMappingURL=api.js.map